export default __webpack_public_path__ + "static/media/NGORealCase1-moblie.08fbf53a.jpg";